export class CellInformation {
  row: number;
  column: number;
  value: string;
}
